import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';

interface QueryErrorProps {
  onRetry?: () => void;
  message?: string;
}

export function QueryError({ onRetry, message }: QueryErrorProps) {
  const { t } = useTranslation();
  return (
    <div className="p-10 flex flex-col items-center text-center gap-3">
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-warn-100 text-warn-600 dark:bg-warn-900/30">
        <AlertTriangle size={18} />
      </div>
      <p className="text-sm text-ink-500">{message ?? t('errors.loadFailed')}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
}
